import {
  GetLoginFeaturesResponse,
  LoginFeatures,
} from '@weave/schema-gen-ts/dist/schemas/login-features/v1/service.pb';
import { AuthStorage, localStorageHelper } from '@frontend/auth-helpers';
import { baseFetch } from './fetch-wrapper';

let loginFeatures: string[] = [];

// old param specific url
const webauthnParam = 'webauthn';
const localStorageFeatureKey = 'login_features';

export const getLoginFeatures = async (): Promise<string[]> => {
  const fingerprint = localStorageHelper.get(AuthStorage.sign_in_fingerprint);
  if (loginFeatures.length > 0) {
    return loginFeatures;
  }
  // uniquely combine features from URL and local storage
  loginFeatures = Array.from(new Set([...featuresFromURL(), ...featuresFromLocalStorage()]));

  const response = await LoginFeatures.GetLoginFeatures(baseFetch<GetLoginFeaturesResponse>(), { fingerprint });
  // uniquely combine features from URL, local storage and response
  loginFeatures = Array.from(new Set([...loginFeatures, ...(response.features || [])]));
  // filter out any features that start with `!`
  loginFeatures = filterOutFeatures(loginFeatures);
  return loginFeatures;
};

function filterOutFeatures(features: string[]) {
  // don't allow webauthn on electron unless we add another feature called 'webauthn-electron'
  if (window.navigator.userAgent.includes('Electron')) {
    features = features.filter((feature) => feature !== 'webauthn');
  }

  // e.g. ['webauthn', '!webauthn'] -> []
  return features.filter((feature) => {
    return !features.includes(`!${feature}`);
  });
}

function featuresFromURL(): string[] {
  const url = new URL(window.location.href);
  const isWebauthn = url.searchParams.get(webauthnParam); // support for the old specific param
  const rawFeatures = url.searchParams.get('_f');
  const features = rawFeatures ? rawFeatures.split(',') : [];
  if (isWebauthn) {
    features.push('webauthn');
  }
  return features;
}

function featuresFromLocalStorage(): string[] {
  const rawFeatures = localStorageHelper.get(localStorageFeatureKey);
  return rawFeatures ? rawFeatures.split(',') : [];
}
